import { useMemo } from 'react';
import DateTime from '@/services/date-time';
import { type INote } from '@/types/INote';
import styles from './index.module.scss';

export default function NoteHead ({ note }: { note: INote }) {
  const contentType = useMemo(() => note.timeTemplate?.type || 'date', [note.timeTemplate]);

  const testAttributeValue = useMemo(() => {
    switch (contentType) {
      case 'date':
        return 'note-date';
      case 'minutes':
        return 'note-minutes';
      case 'text':
        return 'note-text';
      default:
        return '';
    }
  }, [contentType]);
  const content = useMemo(() => {
    switch (contentType) {
      case 'date':
        return DateTime.adaptiveDateTime(new Date(note.publicationDate));
      case 'minutes':
        return [note.timeTemplate?.minutes.base, note.timeTemplate?.minutes.extra]
          .filter(Boolean)
          .map(i => `${i}'`)
          .join(' + ');
      case 'text':
        return note.timeTemplate?.value || '';
      default:
        return '';
    }
  }, [contentType, note.publicationDate, note.timeTemplate]);

  const OrnamentComponent = useMemo(() => {
    if (note.noteIcon) {
      return <img className={styles['note-head__icon']} data-e='note-icon' src={note.noteIcon} />;
    }

    if (note.urgent) {
      return <div className={styles['note-head__urgent-label']} data-e='note-urgent'>Pilne</div>;
    }

    return null;
  }, [note.noteIcon, note.urgent]);

  return (
    <div className={styles['note-head']} data-e='note-head' data-urgent={note.urgent}>
      <span className={styles['note-head__content']} data-e={testAttributeValue}>{content}</span>
      {OrnamentComponent}
    </div>
  );
}
